import addIssue from './addIssue';
import defaultIssues from './default';
import single from './single';

export default {
  default: defaultIssues,
  single,
  addIssue
};
